import { IconButton, useTheme } from '@mui/material';
import { AccountCircleOutlined } from '@mui/icons-material';
import { getButtonInteractionStyles } from './styles';

interface ProfileButtonProps {
  onClick: () => void;
}

export const ProfileButton = ({ onClick }: ProfileButtonProps) => {
  const theme = useTheme();

  return (
    <IconButton
      onClick={onClick}
      aria-label="Profile"
      sx={{
        display: 'flex',
        marginLeft: 'auto',
        width: '48px',
        height: '48px',
        borderRadius: '10px',
        padding: '12px',
        ...getButtonInteractionStyles(theme),
      }}
    >
      <AccountCircleOutlined sx={{ color: theme.palette.neutralGrey[500], fontSize: '24px' }} />
    </IconButton>
  );
};
